import React, { useContext } from 'react'

import { Avatar, Typography, Menu, Tooltip } from 'antd'
import SubMenu from 'antd/lib/menu/SubMenu'
import { UserContext } from '../../core/user-context/user-context-middleware'
import { SignOutButton } from '../../core/authentication/signout-button/signout-button'
// import {userRoles} from '../../core/authentication/graph-service';

const { Text } = Typography

const UserDetailCard: React.FC = () => {
  const userDetails = useContext(UserContext)
  const { userDisplayName, userPhoto, userInitials, userEmail } = userDetails

  const details = () => {
    return (
      <div className="flex flex-row space-x-4 pb-4">
        <div>
          {userPhoto ? (
            <Avatar size={50} src={userPhoto} className="hidden md:block" />
          ) : (
            <Avatar size={50} className="bg-white-600 hidden md:block">
              {userInitials}
            </Avatar>
          )}
        </div>
        <div className="hidden md:block">
          <Tooltip title={userDisplayName} placement="right">
            <Text className="inline-block truncate w-36 title-color text-base font-medium">
              {userDisplayName}
            </Text>
          </Tooltip>
          <Tooltip title={userEmail} placement="right">
            <div className="whitespace-nowrap p-0 text-xs">
              <Text className="text-slate-400 inline-block truncate w-36 title-color text-xs font-normal">
                {userEmail}
              </Text>
            </div>
          </Tooltip>
          {/* <div>
                <Text
                  className="title-color text-base mb-0 font-medium"
                >
                  {role === userRoles.ADMIN ? <div>{'Administrator'}</div> : null} 
                </Text>
              </div> */}
        </div>
      </div>
    )
  }

  const logOutMenuItem = () => {
    return <SignOutButton></SignOutButton>
  }

  return (
    <span className="pt-2 content-end pl-5 inline-block float-right">
      <Menu className="bg-transparent border-0" mode="horizontal">
        <SubMenu className="text-white text-xl" key="user" title={details()}>
          {logOutMenuItem()}
        </SubMenu>
      </Menu>
    </span>
  )
}
export default UserDetailCard
